export function hideWord(word: string, text?: string) {
  const regex = new RegExp(word, 'gi')

  if (!text) return ''

  return text.replace(regex, '')
}
